/**
 * What the sign-in screen reads from the address bar: why the last sign-in ended, when Dob Desktop
 * ended it itself (O33 a, D198: a management sign-in on a shared branch PC left idle).
 */
export interface LoginSearch {
  readonly ended?: 'idle' | undefined;
}

export function loginSearch(input: Record<string, unknown>): LoginSearch {
  return input.ended === 'idle' ? { ended: 'idle' } : {};
}
